import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyles from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
      },
      item: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0px 2px 4px rgb(0 0 0 / 10%)',
        borderRadius: 8,
        cursor: 'pointer',
        userSelect: 'none',
        transition: '.3s ease-in-out',
        '&:not(:last-of-type)': {
          marginBottom: 16,
        },

        '&:hover': {
          background: '#f5f5f5',
        },
      },
      header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing(),
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'column',
        },
      },
      title: {
        flex: 'auto',
        margin: 0,
        fontSize: 14,
        fontWeight: 600,
        color: sicrediStyles.secondarySicrediDarker,
        wordBreak: 'break-word',
        paddingRight: '10px',
        [theme.breakpoints.down('xs')]: {
          paddingRight: '0',
        },
      },
      button: {
        flexShrink: 0,
        fontSize: 16,
        fontWeight: 300,
        textTransform: 'capitalize',
        color: sicrediStyles.primarySicredi,
        padding: '0 8px',
        [theme.breakpoints.down('xs')]: {
          marginTop: '5px',
        },
      },
      description: {
        padding: theme.spacing(),
        margin: 0,
        fontSize: 12,
        color: sicrediStyles.secondarySicrediDarker,
      },
      descriptionMobile: {
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
      descriptionDesktop: {
        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },
      card: {
        overflow: 'hidden',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        borderRadius: '4px',
        background: '#FFFFFF',
        '& > p ': {
          margin: '1rem!important',
          color: '#595959',
        },
        '&:not(:first-child)': {
          margin: '2rem 0rem',
        },
        '& > div ': {
          marginBottom: '0px!important',
        },
        '& > div > div > div': {
          boxShadow: 'unset!important',
          borderRadius: '0px!important',
        },
      },
    }),
  { name: 'AssembleiaVideos' }
);
